exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".searchMenu[data-v-33ec43fc]{width:100%;margin:auto;color:white;text-align:center}.searchMenu .select-style[data-v-33ec43fc]{width:95%}\n", ""]);

// exports
